// components/Forum.tsx
import React, { useState, useEffect } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  Typography,
} from "@mui/material";
import SearchBar from "../../components/SearchBar";
import Pagination from "../../components/Pagination";
import { isValidInput } from "../../utils/validation";
import { useLazyGetAllFormsQuery } from "../../services/forum";
import { APP_ROLE, CONTENT_TYPE } from "../../helpers/constants/enums";
import { useParams } from "react-router-dom";

// Mock short video data
const generateShortVideoData = () =>
  Array.from({ length: 12 }, (_, i) => ({
    id: `short-${i + 1}`,
    title: `Short Video ${i + 1}`,
    views: Math.floor(Math.random() * 10000),
    likes: Math.floor(Math.random() * 500),
    comments: Math.floor(Math.random() * 100),
    shares: Math.floor(Math.random() * 50),
    tips: Math.floor(Math.random() * 2000),
    subscribers: Math.floor(Math.random() * 1000),
    requests: Math.floor(Math.random() * 30),
  }));

const Forum = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [page, setPage] = useState(1);
  const [shortVideos] = useState(generateShortVideoData());
  const [rows, setRows] = useState<any[]>([]);
  const { _id } = useParams();
  const [allVideos] = useLazyGetAllFormsQuery();
  const [totalCount, setTotalCount] = useState<number>(0);
  let totalPages = Math.ceil(totalCount / 10);

  const fetchVideos = async () => {
    try {
      // setIsLoading(true);
      const response = await allVideos({
        page: page,
        search: debouncedSearchTerm,
        createdBy: APP_ROLE.TUTOR,
        contentType: CONTENT_TYPE.FORUM,
        // userId: _id,
        userId: _id as string,
      }).unwrap();
      if (response.statusCode === 200) {
        setRows(response.data?.data);
        setTotalCount(response?.data?.total);
      }
    } catch (error) {
      console.error(error);
    } finally {
      // setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchVideos();
  }, [page, debouncedSearchTerm]);
  return (
    <div>
      <h2 className="mn_hdng">Forums</h2>
      <Grid container spacing={2}>
        {/* <Grid item xs={6}>
          <Typography className="custom_label">
            Total Videos: {shortVideos.length}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography className="custom_label">
            Total Gifts: ${shortVideos.length + 50000}
          </Typography>
        </Grid> */}
        {/* <Grid item xs={6}>
          <Typography className="custom_label">
            Total Videos: {shortVideos.length}
          </Typography>
        </Grid> */}
      </Grid>

      <Box className="cards_header">
        <SearchBar
          value={searchTerm}
          searchTerm={searchTerm}
          onCross={() => setSearchTerm("")}
          setDebouncedSearchTerm={setDebouncedSearchTerm}
          onChange={(val: any) => {
            if (isValidInput(val.target.value)) {
              setSearchTerm(val.target.value);
            }
          }}
        />
      </Box>

      <TableContainer className="table_container">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>S.No</TableCell>
              <TableCell>Title</TableCell>
              <TableCell>Views</TableCell>
              <TableCell>Likes</TableCell>
              <TableCell>Comments</TableCell>
              <TableCell>Shares</TableCell>
              <TableCell>Gift ($)</TableCell>
              <TableCell>Save</TableCell>
              {/* <TableCell>Requests</TableCell> */}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.length > 0 ? (
              rows.map((row, index) => (
                <TableRow key={row.id}>
                  <TableCell>{(page - 1) * 10 + index + 1}</TableCell>
                  <TableCell>{row.title}</TableCell>
                  <TableCell>{row.views}</TableCell>
                  <TableCell>{row.likeCount}</TableCell>
                  <TableCell>{row.commentCount}</TableCell>
                  <TableCell>{row.shareCount}</TableCell>
                  <TableCell>-</TableCell>
                  <TableCell>{row.saveCount}</TableCell>
                  {/* <TableCell>{row.requests}</TableCell> */}
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={9} align="center">
                  No forum found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {rows.length > 0 && (
        <Pagination
          setPage={setPage}
          module={rows}
          page={page}
          totalPages={totalPages}
          onPageChange={setPage}
        />
      )}
    </div>
  );
};

export default Forum;
